<template>
  <div>
    <div class="status font-size-medium">
      Free {{ until }}
    </div>
    <time-buttons
        v-if="!readOnlyMode"
        :disabled="freeMinutes < 5"
        :free-mins="freeMinutes"
        :loading="grabLoading"
        @time="grab"
        class="grab-buttons"
        grab
        v-model="open"/>
  </div>
</template>

<script>
import * as booking from '@/mixins/booking';
import {isSameDay, minutes} from '@/utils/dates';
import {isAbsent} from '@/utils/null';
import {mapActions, mapGetters} from 'vuex';
import TimeButtons from './TimeButtons';

export default {
  name: 'GrabMeeting',
  components: {TimeButtons},
  mixins: [booking.forProperty('nextBooking')],
  data() {
    return {
      now: new Date(),
      nowTicker: 0,
      open: false,
      grabLoading: false
    };
  },
  computed: {
    ...mapGetters('bookings', ['nextBooking']),
    ...mapGetters('config', ['timeFormat', 'readOnlyMode']),
    freeMinutes() {
      if (!this.nextBooking) return Infinity;
      const nextStart = this.reservationStart;
      const now = this.now;
      return Math.trunc((nextStart.getTime() - now.getTime()) / minutes);
    },
    until() {
      const until = this.reservationStart;
      if (isAbsent(until) || !isSameDay(until, this.now)) {
        return 'all day';
      }

      return `until ${this.formatTime(until)}`;
    }
  },
  watch: {
    reservationStart: {
      immediate: true,
      handler: 'scheduleNow'
    }
  },
  methods: {
    ...mapActions('bookings', ['createAdHocBooking']),
    grab(minutes) {
      this.grabLoading = true;
      this.createAdHocBooking(minutes)
          .catch(err => {
            this.$logger.error(err);
            this.$notify.showError('Error grabbing room, please try again');
          })
          .finally(() => {
            this.grabLoading = false;
          });
    },
    scheduleNow() {
      clearInterval(this.nowTicker);

      const timeToMinute = now => now.getTime() - Math.trunc(now.getTime() / minutes) * minutes;
      const tick = () => {
        this.now = new Date();
        if (this.freeMinutes <= 0 || this.freeMinutes === Infinity) return; // nothing to schedule
        this.nowTicker = setTimeout(tick, timeToMinute(this.now));
      };
      tick();
    }
  }
};
</script>

<style scoped>
.status {
  line-height: 1em;
  position: relative;
  top: calc(var(--grid-size) - 1em + 5px);
}

.grab-buttons {
  position: absolute;
  top: calc((2 * var(--grid-size)) - var(--button-height));
}

.offline-notification {
  position: absolute;
  top: calc((2 * var(--grid-size)));
  min-width: calc(1 * var(--button-width));
}
</style>
